const stg = {
  GO_ENDPOINT: 'https://stg.api.vegetablesale.jp/v1/vegetable',
  SLS_GO_ENDPOINT: 'https://stg.api.vegetablesale.jp/v1/admin/vegetable',
  COGNITO_REGION: 'ap-northeast-1',
  COGNITO_USER_POOL_ID: 'ap-northeast-1_910AAkoJA',
  COGNITO_CLIENT_ID: '3nvrd23lb632tstvljckknvstq',
};

export {stg};
